import {Link} from '../../../../../../router';
import {CURRENCY_ITEMS} from '../../../../../../constants';
import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import trim from 'mn-utils/trim';
import * as links from '../../../../../../constants/links';
import withState from '../../../../../../utils/withState';
import {apiAdminPayoutVertoManualUpdate} from '../../../../../../api/admin/payout/verto';
import {openV1PopupInfo} from '../../../../../../emitters/popup';
import LayoutB from '../../../../../dumb/Layout/B';
import CaptionA from '../../../../../dumb/Caption/A';
import HeaderA from '../../../../../dumb/Header/A';
import TextField from '../../../../../dumb/TextField/Reg2';
import ButtonJ from '../../../../../dumb/Button/J';
import Select from '../../../../../dumb/Select/E';
import ButtonBack from '../../../../../dumb/Button/Back';
import KeyboardDatePicker from '../../../../../dumb/KeyboardDatePicker/C';
import KeyboardTimePicker from '../../../../../dumb/KeyboardTimePicker/C';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import {v4 as uuidv4} from 'uuid';

module.exports = withState((setState, self) => {
  const params = self.props.params || {};
  self.state = {
    id: uuidv4(),
    withdrawId: params.id,
    currency: params.currency,
  };

  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeId = changeProvider('id');
  const handleChangeVertoId = changeProvider('vertoId');
  const handleChangeWithdrawId = changeProvider('withdrawId');
  const handleChangeCurrency = handleProvider('currency');
  const handleChangeAmount = changeProvider('amount');
  const handleChangeFee = changeProvider('fee');
  const handleChangeFxRate = changeProvider('fxRate');
  const handleChangeCreatedAt = handleProvider('createdAt');

  return (state, props) => {
    const params = props.params || {};
    const clicked = state.clicked || false;

    const id = state.id || '';
    const _id = trim(id);
    const invalidId = !_id;

    const vertoId = state.vertoId || '';
    const _vertoId = trim(vertoId);
    const invalidVertoId = !_vertoId;

    const withdrawId = state.withdrawId || '';
    const _withdrawId = trim(withdrawId);
    const invalidWithdrawId = !_withdrawId;

    const currency = state.currency || '';
    const _currency = trim(currency);
    const invalidCurrency = !_currency;

    const amount = state.amount || params.amount || '';
    const _amount = trim(amount);
    const invalidAmount = !_amount;

    const fee = state.fee || '';
    const _fee = trim(fee);
    const invalidFee = !_fee;

    const fxRate = state.fxRate || '';
    const _fxRate = trim(fxRate);
    const invalidFxRate = !_fxRate;

    const createdAt = state.createdAt || '';
    const invalidCreatedAt = !createdAt;

    const disabled = invalidId
      || invalidVertoId
      || invalidWithdrawId
      || invalidCurrency
      || invalidAmount
      || invalidFee
      || invalidFxRate
      || invalidCreatedAt;

    return (
      <LayoutB>
        <HeaderA>
          <CaptionA className="fx1 wmin0">Verto manual update</CaptionA>
          <ButtonBack component={Link} href={links.LINK_ADMIN_PAYOUT}/>
        </HeaderA>

        <WrapperWithLoading className="mt30" loading={state.loading}>
          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <TextField
              className="mt20"
              label="ID *"
              value={id}
              error={clicked && invalidId}
              onChange={handleChangeId}
            />
            <TextField
              className="mt20"
              label="Verto ID *"
              value={vertoId}
              error={clicked && invalidVertoId}
              onChange={handleChangeVertoId}
            />
            <TextField
              className="mt20"
              label="Withdraw ID *"
              value={withdrawId}
              error={clicked && invalidWithdrawId}
              onChange={handleChangeWithdrawId}
            />
            <TextField
              className="mt20"
              label="Amount *"
              value={amount}
              error={clicked && invalidAmount}
              onChange={handleChangeAmount}
            />
            <TextField
              className="mt20"
              label="Fee *"
              value={fee}
              error={clicked && invalidFee}
              onChange={handleChangeFee}
            />
            <TextField
              className="mt20"
              label="Fx rate *"
              value={fxRate}
              error={clicked && invalidFxRate}
              onChange={handleChangeFxRate}
            />
            <div className="w mt20">
              <Select
                className="w"
                label="Currency *"
                placeholder="Currency *"
                propValue="id"
                propName="id"
                displayEmpty
                items={CURRENCY_ITEMS}
                value={currency}
                onChange={handleChangeCurrency}
              />
            </div>
            <div className="w mt20 (lt|(w1/2)-10)>1">
              <KeyboardDatePicker
                className="mr10"
                label="Created at date *"
                disableFuture
                value={createdAt}
                error={clicked && invalidCreatedAt}
                onChange={handleChangeCreatedAt}
              />
              <KeyboardTimePicker
                className="ml10"
                label="Created at time *"
                value={createdAt}
                error={clicked && invalidCreatedAt}
                onChange={handleChangeCreatedAt}
              />
            </div>
          </div>

          <div className="pt90 layoutRow fhaB fvaC">
            <ButtonJ
              disabled={clicked && disabled}
              onClick={() => {
                if (disabled) {
                  setState({
                    clicked: true,
                  });
                  return;
                }
                setState({
                  loading: true,
                });

                const params = {
                  id,
                  verto_id: vertoId,
                  withdraw_id: withdrawId,
                  amount,
                  fee,
                  currency,
                  created_at: createdAt,
                  fx_rate: fxRate,
                };

                apiAdminPayoutVertoManualUpdate(params).finally((error) => {
                  setState({
                    loading: false,
                  });
                  error || (
                    openV1PopupInfo([
                      'Success',
                      'Manual update is sent',
                    ])
                  );
                });
              }}
            >Send manual update</ButtonJ>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
});
